import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { MaintenanceEditor } from './-MaintenanceEditor'

export const Route = createFileRoute('/production/maintenance/new')({
  validateSearch: z.object({ machineId: z.string().optional() }),
  component: NewMaintenancePage,
})

function NewMaintenancePage() {
  const { machineId } = Route.useSearch()
  return <MaintenanceEditor machineId={machineId} />
}
